import { createLogger, LOG_NAMESPACES } from '@/utils/logger';
import axiosInstance, { getErrorMessage } from '../axios.config';

const apiLogger = createLogger(LOG_NAMESPACES.API);

export const createDataset = async (body: Record<string, unknown>) => {
  try {
    apiLogger.info('Creating dataset', body);
    const response = await axiosInstance.post('chaincode/dataset', body, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    const message = getErrorMessage(error);
    apiLogger.error('Create dataset error:', message);
    throw new Error(message);
  }
};

export const getAllDatasets = async (id?: string) => {
  try {
    apiLogger.info('Fetching all datasets', { id });
    const response = await axiosInstance.get(`chaincode/dataset/all?space-id=${id}`, {
      withCredentials: true,
    });
    return response.data.result;
  } catch (error) {
    const message = getErrorMessage(error);
    apiLogger.error('Get all datasets error:', message);
    throw new Error(message);
  }
};

export const getDatasetById = async (id?: string) => {
  try {
    apiLogger.info('Fetching dataset by id', { id });
    const response = await axiosInstance.get(`chaincode/dataset/${id}`, {
      withCredentials: true,
    });
    return response.data.result;
  } catch (error) {
    const message = getErrorMessage(error);
    apiLogger.error('Get dataset by id error:', message);
    throw new Error(message);
  }
};

export const updateDataset = async (body: { id: string; name: string }) => {
  try {
    apiLogger.info('Updating dataset', body);
    const response = await axiosInstance.patch(`chaincode/dataset/${body.id}`, body, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    const message = getErrorMessage(error);
    apiLogger.error('Update dataset error:', message);
    throw new Error(message);
  }
};

export const deleteDataset = async (id: string) => {
  try {
    apiLogger.info('Deleting dataset', { id });
    const response = await axiosInstance.delete(`chaincode/dataset/${id}`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    const message = getErrorMessage(error);
    apiLogger.error('Delete dataset error:', message);
    throw new Error(message);
  }
};
